import { LayoutContext } from 'contexts/LayoutContext';
import React, { useContext } from 'react';
import { useModalView } from '@/design-system/components/modal/useModalView.hook';

import { CreateCardAccountStackRoutes, CreateCardAccountStackScreenProps } from './type';
import { CreateCardAccountWebZeroScreen } from './CreateCardAccountWebZero.screen';
import { CreateCardAccountNativeZeroScreen } from './CreateCardAccountNativeZero.screen';

export const CreateCardAccountMain: React.FC<CreateCardAccountStackScreenProps<CreateCardAccountStackRoutes.Main>> = ({
  navigation,
  route
}) => {
  const { onLayout, onData, func, onReturnData, refresh } = route.params;
  const layout = useContext(LayoutContext);
  const onGoBack = () => {
    navigation.goBack();
  };
  const { useModalProps, closeModal } = useModalView({});
  if (layout.isMobile) {
    return (
      <CreateCardAccountNativeZeroScreen
        onClose={onGoBack}
        onLayout={onLayout}
        onData={onData}
        func={func}
        onReturnData={onReturnData}
        refresh={refresh}
      />
    );
  }

  return (
    <CreateCardAccountWebZeroScreen
      onClose={closeModal}
      onLayout={onLayout}
      onData={onData}
      func={func}
      onReturnData={onReturnData}
      refresh={refresh}
    />
  );
};
